import { baseApi } from "@/shared/api";
import type {
  Volunteer,
  VolunteerListResponse,
  CreateVolunteerRequest,
  AssignProjectsRequest,
  AssignProjectsResponse,
  VolunteerListParams,
} from "../types";

export const volunteersApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getVolunteers: builder.query<VolunteerListResponse, VolunteerListParams>({
      query: (params) => {
        const searchParams = new URLSearchParams();
        if (params.search) searchParams.set("search", params.search);
        if (params.active_only !== undefined) searchParams.set("active_only", String(params.active_only));
        if (params.page) searchParams.set("page", String(params.page));
        if (params.page_size) searchParams.set("page_size", String(params.page_size));
        const queryString = searchParams.toString();
        return {
          url: `/api/projects/volunteers/${queryString ? `?${queryString}` : ""}`,
          method: "GET",
          credentials: "include" as const,
        };
      },
      providesTags: [{ type: "Volunteers" as const, id: "LIST" }],
    }),

    createVolunteer: builder.mutation<Volunteer, CreateVolunteerRequest>({
      query: (body) => ({
        url: "/api/projects/volunteers/",
        method: "POST",
        body,
        credentials: "include" as const,
      }),
      invalidatesTags: [{ type: "Volunteers" as const, id: "LIST" }],
    }),

    assignVolunteerProjects: builder.mutation<AssignProjectsResponse, AssignProjectsRequest>({
      query: ({ id, project_ids }) => ({
        url: `/api/projects/volunteers/${id}/assign-projects/`,
        method: "POST",
        body: { project_ids },
        credentials: "include" as const,
      }),
      invalidatesTags: [{ type: "Volunteers" as const, id: "LIST" }],
    }),
  }),
});

export const {
  useGetVolunteersQuery,
  useCreateVolunteerMutation,
  useAssignVolunteerProjectsMutation,
} = volunteersApi;
